import { render } from "./PageWriteNews.vue?vue&type=template&id=9648ca4a&scoped=true"
import script from "./PageWriteNews.vue?vue&type=script&lang=js"
export * from "./PageWriteNews.vue?vue&type=script&lang=js"

import "./PageWriteNews.vue?vue&type=style&index=0&id=9648ca4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9648ca4a"]])

export default __exports__